import React from 'react';
import styles from './SharingItems.module.scss';
import { SharingItemsProps } from './types';

import {
  WhatsappGoldDarkIcon,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
} from 'components/icons';

const SharingItems: React.FC<SharingItemsProps> = ({
  facebookShareUrl,
  emailShareUrl,
  whatsappShareUrl,
  linkedinShareUrl,
}) => {
  return (
    <div className={styles.sharingItems}>
      <a
        href={linkedinShareUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Linkedin"
      >
        <LinkedinIcon />
      </a>
      <a
        href={facebookShareUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
      >
        <FacebookIcon />
      </a>
      <a
        href={emailShareUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share via Email"
      >
        <EmailIcon />
      </a>
      <a
        href={whatsappShareUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on WhatsApp"
      >
        <WhatsappGoldDarkIcon />
      </a>
    </div>
  );
};

export default SharingItems;
